<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                caption="Liste des modèles"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                root="/event-week-template/list"
                :trash="dataTrash">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/event-week-template"
                @onTrashSuccess="onTrashSuccess"
                :caption="window.Core.Definition.getDefinition('Suppression du modèle')"
                :message="window.Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce modèle?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicCardList from '../../components/DynamicCardList'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'EventWeekTemplateList',
        components: {
            DynamicCardList,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                window:window,
                dataColumns: [
                    {
                        label: window.Core.Definition.getDefinition('#'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: window.Core.Definition.getDefinition('Titre'),
                        key: 'title',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'title'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'type'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'title',
                            type: 'text',
                            label: window.Core.Definition.getDefinition('Titre'),
                            value: ''
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                }
            }
        },
        methods: {
            clickEdit(value, cell, row) {
                this.$router.push('/evenement/calendrier/modeles/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
